// extracted by mini-css-extract-plugin
export default {"root":"mimic___style_root__Uei3t"};